import React from 'react';
import './Events.css';

function Guestbook() {
  return (
    <div className="container">
      <h1 className="page-title">Книга Пожеланий</h1>
      
      <div className="events-coming-soon">
        <div className="coming-soon-icon">💌</div>
        <h2>Раздел в разработке</h2>
        <p>
          Здесь будет раздел, где гости сайта смогут оставить пожелания и поздравления Софии.
          Вы сможете оставить тёплые слова и пожелания на будущее.
        </p>
      </div>
    </div>
  );
}

export default Guestbook; 